import React, {useState,useRef,useEffect} from 'react'
import { Row, Col, Container,Collapse,Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, NavLink,} from "reactstrap";
import { loadPlayer } from 'rtsp-relay/browser';

function mainCameras() {
    const [collapsed66, setCollapsed66] = useState(true);
    const [collapsedHeaven, setCollapsedHeaven] = useState(true);
    const [collapsedTropicana, setCollapsedTropicana] = useState(true);
    const [collapsedWarehouse, setCollapsedWarehouse] = useState(true);
    const [collapsedAlbufissa, setCollapsedAlbufissa] = useState(true);
    const [posURL, setPosURL] = useState('http://albufeira66.ddns.net:10001/_internal/nrp.html');
    const [camURL, setCamURL] = useState('wss://celebrationjump.com/ws?test=66p2');
    const [tillURL, setTillURL] = useState('wss://celebrationjump.com/ws?test=66p2till');

    const toggleNavbar = (collapsedHouse,setCollapsed) => setCollapsed(!collapsedHouse);
    const collapseAll =()=>{setCollapsed66(true);setCollapsedHeaven(true);setCollapsedTropicana(true);setCollapsedWarehouse(true);setCollapsedAlbufissa(true)}

    const canvas = useRef(null);
    const canvasTill = useRef(null);
    useEffect( () => {
        if (!canvas.current) throw new Error('Ref is null');
        if (!canvasTill.current) throw new Error('Ref is null');

        
        loadPlayer({
            url:  camURL,
            canvas: canvas.current,loop:false,disconnectThreshold:500,
            onDisconnect: (e) => console.log('Connection lost!',e),
            audio:false
        })

        loadPlayer({
            url:  tillURL,
            canvas: canvasTill.current,loop:false,disconnectThreshold:500,
            onDisconnect: (e) => console.log('Connection lost!',e),
            audio:false
        })
          
    }, [camURL]);

  return (
    <Container>
        <Row >
            <Col md={3} xs={6}>
                <Navbar style={{backgroundColor:'#0b22e8'}} light>
                    <NavbarBrand onClick={()=>toggleNavbar(collapsed66,setCollapsed66)} href="#" className="me-auto text-white">
                    Albufeira 66
                    </NavbarBrand>
                    <NavbarToggler onClick={()=>toggleNavbar(collapsed66,setCollapsed66)} className="me-2" />
                    <Collapse isOpen={!collapsed66} navbar>
                        <Nav navbar onClick={collapseAll}>
                            <NavItem>
                                <NavLink href="#" className='text-white' onClick={()=>{
                                    setPosURL('http://albufeira66.ddns.net:10001/_internal/nrp.html')
                                    setCamURL('wss://celebrationjump.com/ws?test=66p2')
                                    setTillURL('wss://celebrationjump.com/ws?test=66p2till')
                                }}>Bar 1 Posto 2</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink href="#" className='text-white' onClick={()=>{
                                    setPosURL('http://albufeira66.ddns.net:10002/_internal/nrp.html')
                                    setCamURL('wss://celebrationjump.com/ws?test=66p2')
                                    setTillURL('wss://celebrationjump.com/ws?test=66p2till')
                                }}>Bar 1 Posto 2</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink href="#" className='text-white' onClick={()=>{
                                    setPosURL('http://albufeira66.ddns.net:10003/_internal/nrp.html')
                                    setCamURL('wss://celebrationjump.com/ws?test=66p3')
                                    setTillURL('wss://celebrationjump.com/ws?test=66p3till')
                                }}>Bar 1 Posto 3</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink href="#" className='text-white' onClick={()=>{
                                    setPosURL('http://albufeira66.ddns.net:10004/_internal/nrp.html')
                                    setCamURL('wss://celebrationjump.com/ws?test=66p4')
                                    setTillURL('wss://celebrationjump.com/ws?test=66p4till')
                                }}>Bar 2 Posto 4</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink href="#" className='text-white' onClick={()=>{
                                    setPosURL('http://albufeira66.ddns.net:10005/_internal/nrp.html')
                                    setCamURL('wss://celebrationjump.com/ws?test=66p5')
                                    setTillURL('wss://celebrationjump.com/ws?test=66p6till')
                                }}>Bar 2 Posto 5</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink href="#" className='text-white' onClick={()=>{
                                    setPosURL('http://albufeira66.ddns.net:10006/_internal/nrp.html')
                                    setCamURL('wss://celebrationjump.com/ws?test=66p6')
                                    setTillURL('wss://celebrationjump.com/ws?test=66p6till')
                                }}>Bar 2 Posto 6</NavLink>
                            </NavItem>
                        </Nav>
                    </Collapse>
                    <NavbarBrand onClick={()=>toggleNavbar(collapsedHeaven,setCollapsedHeaven)} href="#" className="me-auto text-white">
                    Heaven
                    </NavbarBrand>
                    <NavbarToggler onClick={()=>toggleNavbar(collapsedHeaven,setCollapsedHeaven)} className="me-2" />
                    <Collapse isOpen={!collapsedHeaven} navbar>
                        <Nav navbar onClick={collapseAll}>
                            <NavItem>
                                <NavLink href="#" className='text-white' onClick={()=>{
                                    setPosURL('http://albufeira66.ddns.net:10001/_internal/nrp.html')
                                    localStorage.setItem('camURL','wss://celebrationjump.com/ws?test=66p2')
                                    location.reload()
                                }}>Bar 1 Posto 2</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink href="#" className='text-white' onClick={()=>{
                                    setPosURL('http://albufeira66.ddns.net:10003/_internal/nrp.html')
                                    localStorage.setItem('camURL','wss://celebrationjump.com/ws?test=66p3')
                                    location.reload()
                                }}>Bar 1 Posto 3</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink href="#" className='text-white' onClick={()=>{
                                    setPosURL('http://albufeira66.ddns.net:10004/_internal/nrp.html')
                                    localStorage.setItem('camURL','wss://celebrationjump.com/ws?test=66p4')
                                    location.reload()
                                }}>Bar 2 Posto 4</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink href="#" className='text-white' onClick={()=>{
                                    setPosURL('http://albufeira66.ddns.net:10005/_internal/nrp.html')
                                    localStorage.setItem('camURL','wss://celebrationjump.com/ws?test=66p5')
                                    location.reload()
                                }}>Bar 2 Posto 5</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink href="#" className='text-white' onClick={()=>{
                                    setPosURL('http://albufeira66.ddns.net:10006/_internal/nrp.html')
                                    localStorage.setItem('camURL','wss://celebrationjump.com/ws?test=66p6')
                                    location.reload()
                                }}>Bar 2 Posto 6</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink href="#" className='text-white' onClick={()=>{
                                    setPosURL('http://albufeira66.ddns.net:10006/_internal/nrp.html')
                                    localStorage.setItem('camURL','wss://celebrationjump.com/ws?test=66p6')
                                    location.reload()
                                }}>Bar 3 Posto 7</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink href="#" className='text-white' onClick={()=>{
                                    setPosURL('http://albufeira66.ddns.net:10006/_internal/nrp.html')
                                    localStorage.setItem('camURL','wss://celebrationjump.com/ws?test=66p6')
                                    location.reload()
                                }}>Bar 3 Posto 8</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink href="#" className='text-white' onClick={()=>{
                                    setPosURL('http://albufeira66.ddns.net:10006/_internal/nrp.html')
                                    localStorage.setItem('camURL','wss://celebrationjump.com/ws?test=66p6')
                                    location.reload()
                                }}>Bar 4 Posto 9</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink href="#" className='text-white' onClick={()=>{
                                    setPosURL('http://albufeira66.ddns.net:10006/_internal/nrp.html')
                                    localStorage.setItem('camURL','wss://celebrationjump.com/ws?test=66p6')
                                    location.reload()
                                }}>Bar VIP</NavLink>
                            </NavItem>
                        </Nav>
                    </Collapse>
                    <NavbarBrand onClick={()=>toggleNavbar(collapsedTropicana,setCollapsedTropicana)} href="#" className="me-auto text-white">
                    Tropicana
                    </NavbarBrand>
                    <NavbarToggler onClick={()=>toggleNavbar(collapsedTropicana,setCollapsedTropicana)} className="me-2" />
                    <Collapse isOpen={!collapsedTropicana} navbar>
                        <Nav navbar onClick={collapseAll}>
                            <NavItem>
                                <NavLink href="#" className='text-white' onClick={()=>{
                                    setPosURL('http://albufeira66.ddns.net:10001/_internal/nrp.html')
                                    localStorage.setItem('camURL','wss://celebrationjump.com/ws?test=66p2')
                                    location.reload()
                                }}>Bar 1 Posto 1</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink href="#" className='text-white' onClick={()=>{
                                    setPosURL('http://albufeira66.ddns.net:10003/_internal/nrp.html')
                                    localStorage.setItem('camURL','wss://celebrationjump.com/ws?test=66p3')
                                    location.reload()
                                }}>Bar 1 Posto 2</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink href="#" className='text-white' onClick={()=>{
                                    setPosURL('http://albufeira66.ddns.net:10004/_internal/nrp.html')
                                    localStorage.setItem('camURL','wss://celebrationjump.com/ws?test=66p4')
                                    location.reload()
                                }}>Bar 2 Posto 3</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink href="#" className='text-white' onClick={()=>{
                                    setPosURL('http://albufeira66.ddns.net:10005/_internal/nrp.html')
                                    localStorage.setItem('camURL','wss://celebrationjump.com/ws?test=66p5')
                                    location.reload()
                                }}>Bar 2 Posto 4</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink href="#" className='text-white' onClick={()=>{
                                    setPosURL('http://albufeira66.ddns.net:10006/_internal/nrp.html')
                                    localStorage.setItem('camURL','wss://celebrationjump.com/ws?test=66p6')
                                    location.reload()
                                }}>Bar 3 Posto 5</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink href="#" className='text-white' onClick={()=>{
                                    setPosURL('http://albufeira66.ddns.net:10006/_internal/nrp.html')
                                    localStorage.setItem('camURL','wss://celebrationjump.com/ws?test=66p6')
                                    location.reload()
                                }}>Bar 3 Posto 6</NavLink>
                            </NavItem>
                        </Nav>
                    </Collapse>
                    <NavbarBrand onClick={()=>toggleNavbar(collapsedWarehouse,setCollapsedWarehouse)} href="#" className="me-auto text-white">
                    Warehouse
                    </NavbarBrand>
                    <NavbarToggler onClick={()=>toggleNavbar(collapsedWarehouse,setCollapsedWarehouse)} className="me-2" />
                    <Collapse isOpen={!collapsedWarehouse} navbar>
                        <Nav navbar onClick={collapseAll}>
                            <NavItem>
                                <NavLink href="#" className='text-white' onClick={()=>{
                                    setPosURL('http://albufeira66.ddns.net:10001/_internal/nrp.html')
                                    localStorage.setItem('camURL','wss://celebrationjump.com/ws?test=66p2')
                                    location.reload()
                                }}>Bar 1 Posto 1</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink href="#" className='text-white' onClick={()=>{
                                    setPosURL('http://albufeira66.ddns.net:10003/_internal/nrp.html')
                                    localStorage.setItem('camURL','wss://celebrationjump.com/ws?test=66p3')
                                    location.reload()
                                }}>Bar 1 Posto 2</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink href="#" className='text-white' onClick={()=>{
                                    setPosURL('http://albufeira66.ddns.net:10004/_internal/nrp.html')
                                    localStorage.setItem('camURL','wss://celebrationjump.com/ws?test=66p4')
                                    location.reload()
                                }}>Bar 2 Posto 3</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink href="#" className='text-white' onClick={()=>{
                                    setPosURL('http://albufeira66.ddns.net:10005/_internal/nrp.html')
                                    localStorage.setItem('camURL','wss://celebrationjump.com/ws?test=66p5')
                                    location.reload()
                                }}>Bar 2 Posto 4</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink href="#" className='text-white' onClick={()=>{
                                    setPosURL('http://albufeira66.ddns.net:10006/_internal/nrp.html')
                                    localStorage.setItem('camURL','wss://celebrationjump.com/ws?test=66p6')
                                    location.reload()
                                }}>Bar 3 Posto 5</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink href="#" className='text-white' onClick={()=>{
                                    setPosURL('http://albufeira66.ddns.net:10006/_internal/nrp.html')
                                    localStorage.setItem('camURL','wss://celebrationjump.com/ws?test=66p6')
                                    location.reload()
                                }}>Bar 3 Posto 6</NavLink>
                            </NavItem>
                        </Nav>
                    </Collapse>
                    <NavbarBrand onClick={()=>toggleNavbar(collapsedAlbufissa,setCollapsedAlbufissa)} href="#" className="me-auto text-white">
                    Albufissa
                    </NavbarBrand>
                    <NavbarToggler onClick={()=>toggleNavbar(collapsedAlbufissa,setCollapsedAlbufissa)} className="me-2" />
                    <Collapse isOpen={!collapsedAlbufissa} navbar>
                        <Nav navbar onClick={collapseAll}>
                            <NavItem>
                                <NavLink href="#" className='text-white' onClick={()=>{
                                    setPosURL('http://albufeira66.ddns.net:10001/_internal/nrp.html')
                                    localStorage.setItem('camURL','wss://celebrationjump.com/ws?test=66p2')
                                    location.reload()
                                }}>Bar 1 Posto 1</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink href="#" className='text-white' onClick={()=>{
                                    setPosURL('http://albufeira66.ddns.net:10003/_internal/nrp.html')
                                    localStorage.setItem('camURL','wss://celebrationjump.com/ws?test=66p3')
                                    location.reload()
                                }}>Bar 1 Posto 2</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink href="#" className='text-white' onClick={()=>{
                                    setPosURL('http://albufeira66.ddns.net:10004/_internal/nrp.html')
                                    localStorage.setItem('camURL','wss://celebrationjump.com/ws?test=66p4')
                                    location.reload()
                                }}>Bar 2 Posto 3</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink href="#" className='text-white' onClick={()=>{
                                    setPosURL('http://albufeira66.ddns.net:10005/_internal/nrp.html')
                                    localStorage.setItem('camURL','wss://celebrationjump.com/ws?test=66p5')
                                    location.reload()
                                }}>Bar 2 Posto 4</NavLink>
                            </NavItem>
                        </Nav>
                    </Collapse>
                </Navbar>
            </Col>
            <Col md={9} xs={6} style={{transform: 'scale(0.5)', transformOrigin: '0 0'}} className='text-center' >
                <canvas id='canvas'  ref={canvas} style={{width:'900px',height:'600px',display:'block'}}/>
                <iframe src={posURL} width="900px" height="600px" frameBorder="0" className='ml-5' > </iframe>
                <canvas id='canvasTill'  ref={canvasTill} style={{width:'900px',height:'600px',display:'block'}}/>
            </Col>
        </Row>
    </Container>
  )
}

export default mainCameras